import { api } from '../lib/api.ts'
import { A, url } from '@01edu/signal-router'
import { effect } from '@preact/signals'
import { ChevronRight, ExternalLink } from 'lucide-preact'

const getProject = api['GET/api/project'].signal()

effect(() => {
  const project = url.params.project
  project ? getProject.fetch({ project }) : getProject.reset()
})

const Separator = () => (
  <ChevronRight size={14} class='shrink-0 text-base-content/30' />
)

export const Breadcrumbs = () => {
  const projectDomain = getProject.data?.projectDomain
  if (!projectDomain) return null

  const { project, license } = url.params

  return (
    <nav
      aria-label='Breadcrumb'
      class='mx-2 hidden sm:flex items-center gap-2 text-sm'
    >
      <A
        href='/'
        params={{ project: null, license: null, view: null }}
        class='text-base-content/60 hover:text-base-content'
      >
        Projects
      </A>
      <Separator />
      {license
        ? (
          <>
            <A
              params={{ project, license: null, scope: null }}
              class='text-base-content/60 hover:text-base-content font-medium'
            >
              {projectDomain}
            </A>
            <Separator />
            <span class='font-semibold text-primary'>License #{license}</span>
          </>
        )
        : <span class='font-semibold text-primary'>{projectDomain}</span>}
      <a
        href={`https://${projectDomain}`}
        class='ml-1 text-primary hover:text-base-content'
        title={`Open ${projectDomain}`}
        target='_blank'
        rel='noopener noreferrer'
      >
        <ExternalLink size={14} class='block' />
      </a>
    </nav>
  )
}
